import { AddOutlined, Delete, DragIndicator } from '@mui/icons-material';
import { Grid, IconButton } from '@mui/material';
import { styled } from '@mui/material';
import { Row } from 'further-ui/components/Layout';
import React from 'react';

const HiddenRow = styled(Row)(() => ({
  visibility: 'hidden',
}));

type Props = {
  rate: React.ReactNode;
  dpiThreshold?: React.ReactNode;
  actions: React.ReactNode;
};

const CarriedInterestRateRowLayout: React.FC<Props> = ({
  rate,
  dpiThreshold,
  actions,
}) => (
  <Row fullWidth centered>
    <Grid container spacing={6} width="100%">
      <Grid size={{ xs: 6 }}>{rate}</Grid>
      {dpiThreshold ? <Grid size={{ xs: 6 }}>{dpiThreshold}</Grid> : null}
    </Grid>
    {actions}
  </Row>
);

export const RateRowActionsSpacer: React.FC = () => (
  <HiddenRow centered>
    <IconButton size="small">
      <AddOutlined fontSize="small" />
    </IconButton>
    <IconButton size="small">
      <Delete fontSize="small" />
    </IconButton>
    <DragIndicator />
  </HiddenRow>
);

export default CarriedInterestRateRowLayout;
